// extracted by mini-css-extract-plugin
export default {"contactSection":"authors_contactSection__jb5Js","photoAndText":"authors_photoAndText__16ixO","photoContainer":"authors_photoContainer__hlQXS","photo":"authors_photo__7f0Nn"};